import { AmbientConversation } from "../../api/ambientConversation.type";
import { SubmitButton } from "../shared/buttons/submit-button";
import Typography from "../shared/typography";
import { AnalysisPanel } from "./analysis-panel";
import { AudioPlayer } from "./audio-player";

export function AmbientConvoDetail({
  conversation,
  onAnalyze,
  onDelete,
}: {
  conversation: AmbientConversation | null;
  onAnalyze: (id: string) => void;
  onDelete: (id: string) => void;
}) {
  if (!conversation) {
    return <div className="p-4">Select a conversation to view details</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Typography variant="h4">
          {conversation.title || "Conversation"}
        </Typography>
        <SubmitButton
          size="sm"
          color="brown"
          onClick={() => onDelete(conversation.id)}
          hideArrow
        >
          Delete
        </SubmitButton>
      </div>
      <AudioPlayer sources={conversation.audio_urls} />
      {conversation.analysis ? (
        <AnalysisPanel analysis={conversation.analysis} />
      ) : (
        <SubmitButton onClick={() => onAnalyze(conversation.id)}>
          Analyze
        </SubmitButton>
      )}
    </div>
  );
}
